import {
  Highlights,
  WtpBlue,
  Deadline,
  Red,
  Title,
  List,
  Item,
  Bold,
  Description,
  SectionHeader,
  Diamond,
  DTitle,
  DLine,
} from "./commonDraw";

const Kr = {
  aboutPage: {
    title: "소개",
    about_1: (
      <>
        위더피플 법률사무소는 2010년 설립 이후 기업자문, 공정거래·기업분쟁 및 지식재산권 사건을 다뤄 왔습니다. 기술기업의 기술권리 보호와 사업화, 해외거래, 미국 비즈니스·소송 및 관세·통상 문제를 기업자문과 분쟁 대응의 관점에서 함께 검토합니다.
        <br />
        <br />
  위더피플의 업무분야는 ① 기술기업 자문, ② IP·기술권리 전략, ③ 글로벌 진출·수출 자문, ④ 미국 비즈니스·소송 대응의 네 영역으로 나뉩니다. 실제 기업의 사업 과정에서는 이들 문제가 서로 맞물리는 경우가 많으므로, 사안에 따라 관련 영역을 함께 검토합니다.
        <br />
        <br />
 하나의 기술사업 계약에도 투자·지배구조, IP 귀속과 라이선스, 관세·통관, 수출통제 및 미국법상 분쟁 가능성이 함께 얽힐 수 있습니다. 위더피플은 각 쟁점을 따로 떼어 보기보다 고객의 사업모델, 기술자산, 거래상대방과 목표시장을 기준으로 무엇을 먼저 검토하고 실행할지 정리합니다.
        <br />
        <br />
      게임·콘텐츠, AI·소프트웨어, 반도체·전자, 모빌리티·배터리, 디지털자산 등 기술과 무형자산이 중요한 산업을 중점적으로 지원합니다. 여러 전문영역이나 국가가 관련된 사안에서도 위더피플이 한국 본사와 직접 소통하며, 국내 자문과 해외 절차가 일관된 방향으로 진행되도록 업무를 주도합니다.
        <br />
        <br />
  기술기업이 실제로 판단하고 실행할 수 있도록 기업자문, IP, 해외거래·관세 및 미국 비즈니스·소송에 필요한 법률서비스를 제공하겠습니다.
        <br />
        <br />

      </>
    ),
    feature_1_title: `기술과 산업을 잇는 지식재산권 전문성`,

    feature_1_text: `리인터내셔널 특허법률사무소, Lucid Insights, Creative Answers (LICA), 그리고 특허법인 위더피플과의 협업을 통해 특허·상표·저작권 전 분야의 출원, 분쟁, 거래를 수행합니다. 국내외 기업의 특허 포트폴리오 구축에서 미국 특허출원 및 심사 대응까지 통합적인 지원 체계를 갖추고 있습니다. 기술과 산업의 경계를 아우르는 IP 전략으로 기업의 혁신과 시장 경쟁력을 강화합니다.`,
    feature_2_title: `파트너십으로 확장하는 게임 산업의 법률 전문성`,
    feature_2_text: `콘텐츠 라이선스, 지식재산권 및 영업비밀 보호, 국내외 퍼블리싱 관련 법규 준수 등 게임 산업 전반에 걸친 폭넓은 전문 역량을 보유하고 있습니다. 게임 개발부터 서비스 운영, 퍼블리싱, 글로벌 진출에 이르기까지 각 단계에서 발생할 수 있는 법적 이슈를 체계적으로 관리하고, 실무 중심의 솔루션을 제공합니다. 또한 위더피플 플러스 게임컨설팅, 큐로드(QROAD), 한국모바일게임협회, 한국인공지능게임협회 등 주요 산업 파트너와의 긴밀한 협력을 통해, 현장의 경험과 정책적 통찰을 결합한 통합적 법률·비즈니스 지원 체계를 구축하고 있습니다.`,
    feature_3_title: `국제소송의 강자, 정의와 휴머니티로 권익 보호 `,
    feature_3_text: `15년 이상 주요 글로벌 국제소송을 선도하며 국내외 기업과 개인의 권익 보호를 위해 힘써왔습니다. 세계적인 국제소송 전문 로펌 Hausfeld와의 긴밀한 협력을 바탕으로 해당 분야에서 독보적인 경쟁력을 갖추고 있습니다.`,
    feature_4_title: `China Desk – 한중 비즈니스의 전략적 파트너`,
    feature_4_text: `중국 변호사 출신 고문단, 중국인 전문 인력을 보유하고 있으며, 폭넓은 현지 네트워크를 바탕으로 중국 기업의 한국 진출과 한국 기업의 중국 진출 모두에서 차별화된 강점을 발휘하며, 투자, 합작, 지식재산권 등 주요 현안에 대한 해결책을 제시합니다.`,
  },
  samplePage: {
    title: (
      <>
        <Highlights>
          구글·애플 앱마켓 과도한 수수료,{" "}
          <span style={{ whiteSpace: "nowrap" }}> 위더피플 법률사무소가</span>
        </Highlights>
        <br />
        손해배상금을
        <Deadline> 찾아드려요 !</Deadline>
      </>
    ),
    subTitle: (
      <>
        {" "}
        부당하게 과다 지불한 수수료, 집단 조정을 통해 손해 배상을 신청하세요.
        <br />
        <WtpBlue>
          참여 비용은 없으며, 'No Win, No Fee' 원칙에 따라 진행됩니다.{" "}
        </WtpBlue>
        미국 집단소송 전문 로펌 Hausfeld와 함께 성공적인 합의를 이끌어냅니다.
      </>
    ),

    deadline: (
      <>
        {" "}
        <Highlights>추가 신청 마감: 2025년 5월 31일</Highlights>
        <br /> ( ※ 접수순으로 손해감정이 진행됩니다)
      </>
    ),

    applyBt: <>지금 바로 신청하기</>,
    learnMore: <>자세히 알아보기</>,

    section_1_title: `집단 조정 개요`,

    section_1_dec_1: (
      <>
        구글과 애플의 독점적 지위를 이용한{" "}
        <WtpBlue>30% 인앱결제 수수료</WtpBlue> 등 불공정 행위로 인해 국내 앱
        개발사들이 입은 피해에 대한 집단적 손해배상 및 합의 절차입니다.
      </>
    ),
    section_1_dec_2: (
      <>
        {" "}
        위더피플 법률사무소는 미국 집단소송 전문 로펌{" "}
        <WtpBlue>하우스펠드(Hausfeld LLP)</WtpBlue>와 공동으로 '제소 전
        화해'(합의) 형식의 손해배상을 추진하고 있습니다.
      </>
    ),
    section_1_dec_3: (
      <>
        {" "}
        하우스펠드 로펌은 2023년 미국에서 4만 8천개 앱 업체를 대리하여
        구글로부터 동일 사안의{" "}
        <WtpBlue>합의금을 성공적으로 받아낸 경험</WtpBlue>이 있습니다.
      </>
    ),
    section_1_dec_4: <></>,
    section_1_dec_5: (
      <>이제 함께 목소리를 내어 정당한 권리를 되찾을 때입니다.</>
    ),
    section_2_title: <>신청 대상</>,
    section_2_dec: (
      <>
        다음 조건에 해당하시는 국내·해외 앱 개발사(개인 개발자 포함)라면 누구나
        신청 가능합니다:
      </>
    ),

    section_2_li_1: (
      <>
        {" "}
        구글 플레이스토어 또는 애플 앱스토어를 통해 앱(게임 포함)을 유통한 경우
      </>
    ),

    section_2_li_2: (
      <>
        {" "}
        <WtpBlue>
          구글 또는 애플의 인앱결제 시스템을 사용해 수수료를 납부한 경험이 있는
          경우
        </WtpBlue>
      </>
    ),

    section_3_title: <>참여해야 하는 이유</>,
    section_3_li_1: (
      <>
        <WtpBlue>비용 부담 없이 참여 가능:</WtpBlue> 신청부터 배상금 수령까지
        개발사에는 별도의 비용 부담이 없습니다. 성공 보수 방식(No Win, No
        Fee)으로 진행됩니다.
      </>
    ),
    section_3_li_2: (
      <>
        {" "}
        <WtpBlue>높은 손해배상 가능성:</WtpBlue> 미국에서 동일 소송을 성공적으로
        수행한 하우스펠드 로펌과 협력하여 국내 게임사들의 피해에 대해 정당한
        손해배상을 받을 수 있도록 지원합니다.
      </>
    ),
    section_3_li_3: (
      <>
        {" "}
        <WtpBlue>의미 있는 배상 규모 예상:</WtpBlue> 제출된 자료에 대한 전문
        손해 감정을 통해, 실제 손실을 반영한 합리적인 배상금이 산정됩니다.
      </>
    ),
    section_3_li_4: (
      <>
        {" "}
        <WtpBlue>국내외 전문가의 공동 대응:</WtpBlue> 국내 법률 전문가 위더피플
        법률사무소와 미국 하우스펠드 로펌이 긴밀히 협력하여 개발사의 권익 보호를
        함께 이끌어갑니다.
      </>
    ),
    section_3_li_5: (
      <>
        {" "}
        <WtpBlue>더 나은 제도 개선의 시작점:</WtpBlue> 이번 조정 참여는 단순한
        배상에 그치지 않고, 장기적으로 더 공정하고 투명한 수수료 정책이 마련되는
        계기가 될 수 있습니다.
      </>
    ),
    section_3_li_6: (
      <>
        {" "}
        <WtpBlue>집단 대응을 통한 실질적 해결:</WtpBlue> 개별 소송의 부담 없이,
        집단의 힘을 통해 대형 플랫폼 기업에 보다 효과적으로 대응할 수 있는
        현실적인 해결 방안입니다.
      </>
    ),
    section_4_title: <>플랫폼의 보복 조치가 걱정되시나요?</>,

    section_4_des_1: (
      <>
        {" "}
        <WtpBlue>
          이번 미국 집단조정은 앱 개발사와 구글·애플 간 체결된 계약에 따라
          미국법이 적용되며, 참여 기업은 미국 법원의 보호 아래 보복 우려 없이
          안전하게 권리를 행사할 수 있습니다.
        </WtpBlue>
      </>
    ),
    section_4_des_2: (
      <>
        실제로 지금까지 구글과 애플을 상대로 수많은 기업이 개별 및 집단 소송,
        청구권 협상에 참여했으나, 보복 피해 사례는 단 한 건도 보고된 바
        없습니다.
      </>
    ),
    section_4_li_1: <>구글 집단소송: 약 4만 8천개 미국 앱 업체</>,
    section_4_li_2: <>애플 집단소송: 약 6만 7천개 미국 앱 업체</>,
    section_4_li_3: <>미국 소비자 대상 손해배상 합의: 약 9,100억 원</>,

    section_4_des_3: (
      <>
        {" "}
        총 배상 합의금 규모는 약 1조 1천억 원에 달하며, 그 과정에서 앱 업체들에
        대한 위협이나 보복 행위는 확인되지 않았습니다.
      </>
    ),
    section_4_des_4: (
      <>
        {" "}
        <WtpBlue>미국 반독점법 (Sherman Act) </WtpBlue>{" "}
      </>
    ),
    section_4_des_4_5: (
      <>미국법은 영업보복 행위 자체를 또 다른 반독점법 위반으로 간주합니다.</>
    ),
    section_4_des_5: (
      <>
        {" "}
        위반 시, 위법 행위 1건당 최대 1억 달러의 벌금 또는 최대 10년 이하의 징역
      </>
    ),
    section_4_des_6: <> 민사상으로는 3배의 징벌적 손해배상 가능</>,
    section_4_des_7: (
      <>
        {" "}
        <WtpBlue>미국법원 판례</WtpBlue>
      </>
    ),
    section_4_des_8: <> 기업에는 거래 상대방 선택의 자유가 있으나,</>,
    section_4_li_4: <> 소송 방해 또는 독점 유지 목적의 조치는 불법이며,</>,
    section_4_li_5: (
      <>
        {" "}
        영업관계의 일방적 중단, 종료 또는 영업방해 등 보복 행위가 발생할 경우,
      </>
    ),

    section_4_des_9: (
      <> 법원은 즉각적인 금지명령(injunction)을 통해 이를 차단합니다.</>
    ),
    section_5_title: <> 신청 절차</>,
    section_5_sub: (
      <>
        {" "}
        집단 조정 신청부터 배상까지의 절차는 다음과 같이 진행됩니다. (미국 집단
        조정 절차 기준, 통상 6개월~1년 소요)
      </>
    ),
    section_5_table: [
      {
        title: "신청 접수 (온라인)",
        description:
          "홈페이지를 통해 개발사 기본 정보를 입력하고 신청서를 제출합니다.",
      },
      {
        title: "검토 및 상담",
        description:
          "제출된 신청서를 바탕으로 위더피플 법률사무소에서 신청 기업 자료 요청 및 상담을 진행합니다.",
      },
      {
        title: "손해액 산정 및 심사",
        description:
          "미국 집단소송 전문 로펌 하우스펠드가 제출된 자료를 검토하여 개발사별 손해액을 감정하고 심사합니다.",
      },
      {
        title: "조정/합의 진행",
        description:
          "위더피플 법률사무소와 하우스펠드 로펌이 개발사를 대리하여 구글/애플과 제소 전 손해배상 합의를 위한 협상을 진행합니다. \n( 미국 전담 중재인 Mediator Layn Phillips )",
      },
      {
        title: "결과 통보 및 배상",
        description:
          "합의가 성공적으로 이루어지면, 그 결과를 참여 개발사에게 통보하고 합의된 배상금을 지급하는 절차를 진행합니다.",
      },
    ],
    section_6_title: "신청 방법",
    section_6_des_1: (
      <>
        신청 마감: <Deadline>2025년 5월 31일 </Deadline>{" "}
      </>
    ),
    section_6_des_2: <>(접수순으로 진행됨)</>,
    section_6_des_3: (
      <>아래 버튼을 클릭하여 지금 바로 집단조정 참여를 신청하세요!</>
    ),
    section_6_des_4: "신청하기",

    section_6_des_5: (
      <>
        {" "}
        신청서 접수 후, 담당자가 내용 확인을 위해 연락드릴 예정입니다.
        <br />
        신청 과정에 대해 궁금한 점이 있으시면 언제든지 아래 연락처로
        문의해주세요.
      </>
    ),
    section_7_title: "문의처",
    section_7_des_1: (
      <>
        집단조정 참여와 관련하여 궁금한 점이 있으시면 언제든지 연락 주시기
        바랍니다.
      </>
    ),
    section_7_des_2: (
      <>
        <WtpBlue>담당:</WtpBlue> 위더피플 법률사무소 / 이영기 외국 변호사
      </>
    ),
    section_7_des_3: (
      <>
        {" "}
        <WtpBlue>전화:</WtpBlue> +82 2 2285 0062
      </>
    ),
    section_7_des_4: <WtpBlue>이메일</WtpBlue>,
    section_7_des_4_5: <WtpBlue>신청 페이지</WtpBlue>,
    section_7_des_5: <></>,
    section_7_des_6: "https://wtplaw.co.kr/kr/app_apply",
  },
  apply: {
    m: "유효한 이메일 주소를 입력해주세요.",
    file: "파일은 5MB 이하만 업로드할 수 있습니다.",
    alert: "상담 신청이 잘 접수되었습니다. 곧 연락 드리겠습니다.",
    title: "집단 조정 상담 신청서",
    A_1: (
      <>
        <Red>[필수]</Red> 회사명(국문)
      </>
    ),
    A_2: <>[선택] 회사명(영문)</>,
    A_3: (
      <>
        {" "}
        [법인] 법인등기부상 영문명과 동일{"\n"}
        [개인사업자] 영문사업자명 정확하게 기재
      </>
    ),
    A_4: (
      <>
        {" "}
        <Red>[필수]</Red> 대표자명(국문)
      </>
    ),
    A_5: <>[선택] 대표자명(영문)</>,
    A_6: <>여권상 영문명과 동일</>,
    A_7: (
      <>
        {" "}
        <Red>[필수]</Red> 담당자명
      </>
    ),
    A_8: (
      <>
        <Red>[필수]</Red> 휴대폰번호
      </>
    ),
    A_9: <>[선택] 회사전화번호</>,
    A_10: (
      <>
        <Red>[필수]</Red> 이메일
      </>
    ),

    A_11: <>[첨부] 위임장 양식</>,
    A_12: <>다운로드</>,
    A_13: <> [선택] [제출서류] [위임장 날인본] [업로드]</>,
    A_13_5: <> 첨부하기</>,

    A_14: <>선택된 파일 없음</>,
    A_15: <> *혹은 이메일로 제출{" \n"}</>,
    A_16: (
      <>
        {" "}
        개인정보 수집 및 이용에 동의합니다.
        <br />
        수집 항목: 성명/회사명, 전화번호, 이메일
        <br />
        수집 목적: 집단 조정 절차의 상담
        <br />
        보유 및 이용 기간: 조정 절차 종료 후 1년까지 보관 후 파기
        <br />
        귀하는 동의를 거부할 권리가 있으며, 다만 동의하지 않을 경우 신청이
        제한될 수 있습니다.
      </>
    ),
    A_17: <>신청서 제출</>,
  },

  footer: {
    mainTitle: `위더피플 법률사무소`,
    mainText_1: `위더피플의 ‘위(爲)’는 ‘고객을 위(爲)한다’는 의미를 담고 있습니다.
                `,
    mainText_2: `
                당신의 든든한 법률·비지니스 파트너가 되겠습니다.`,
    tel: `연락처`,
    map: `서울특별시 서대문구 경기대로 47, 진양빌딩 7층`,
    phone: `02-2101-0750`,
    sub: `위더피플 인앱피해 공동대응 사무국`,
    subMap_1: `서울특별시 구로구 디지털로31길 20,`,
    subMap_2: `에이스테크노타워 5차
                  704호`,
    subp_1: "070-4699-0107",
    subp_2: "010-8485-5743",
    subp_3: "050-4171-8975",
    fax: `팩스`,
  },
  header: {
    nav: {
      home: "홈",
      intro: "소개",
      practice: "업무분야",
      member: "구성원",
      international: "CSV Litigation Center",
      monetization: "IP Monetization Center",
      notice: "공지",
      news: "언론보도",
      cases: "주요사례",
      insight: "인사이트",
      Partners: "Family Site",
      wethepeople: "특허법인 위더피플",
      pharos: "노무법인 파로스",
      game: "(사)한국모바일게임협회",
      indie: "(사)한국인공지능게임협회",
      updates: "소식",
      publications: "기고문",
      newsletters: "뉴스레터",
      recruit: "모집중인 소송",

      track: "주요 Track Record",
      contact: "문의",
    },
  },
  homepage: {
    slider: [
      {
        id: 1,
        backgroundImage: "/images/home/main_1.png",
        title: "신뢰와 전문성으로 함께하는\n법률 파트너",
        subtitle:
          "위더피플 법률사무소는 지식재산권, 기업법무, 소송 등 다양한 분야에서\n맞춤형 법률 서비스를 제공합니다.",
        buttonText: "법률 상담 문의하기",
        buttonLink: "/contact",
      },
      {
        id: 2,
        backgroundImage: "/images/home/main_5.png",
        title: "글로벌 역량과 전문성을 갖춘\n법률 전문가 그룹",
        subtitle: "국내외 복잡한 법률 이슈에 대한 최적의 솔루션을 제공합니다.",
        buttonText: "더 알아보기",
        buttonLink: "/about",
      },
      {
        id: 3,
        backgroundImage: "/images/home/main_3.png",
        title: "고객의 권리 보호와 성공을 위한\n최선의 노력",
        subtitle:
          "위더피플의 '위(爲)'는 '고객을 위(爲)한다'는 의미를 담고 있습니다.",
        buttonText: "성공 사례 보기",
        buttonLink: "/cases",
      },
    ],
    search: "구성원 검색",
    searchEx: "이름으로 검색",
    searchBt: "검색",
    popImage: "/images/event/popup_new.png",
  },
  PracticeAreasPage: {
    title: "전문분야",
    practice: "업무분야",
    special: "핵심 역량 및 특화 서비스",
    normal: "일반 기업법무 서비스",
    sector: "산업분야",
    learnMore: "자세히 보기",
  },
  PracticeAreasDetailPage: {
    home: "홈",
    area: "전문분야",
    introduction: "소개",
    service: "주요 서비스",
  },
  memberPage: {
    professionals: "구성원",
    proSearch: "구성원 검색",
    search: "검색",
    holder: "이름으로 검색",
  },
  memberDetailPage: {
    home: "홈",
    member: "구성원",
    intro: "Introduction",
    history: "경력",
    education: "학력",
    performance: "주요 실적",
    lan: "언어",
    insight: "인사이트",
    awards: "수상 내역",
    qualifications: "자격",
  },
  noticePage: {
    home: "소식",
  },
  noticeDetailPage: {
    home: "홈",
    announcements: "소식",
    backtoList: "목록으로 돌아가기",
    previous: "이전글",
    next: "다음글",
  },
  newsPage: {
    home: "언론보도",
  },
  publicationPage: {
    home: "기고문",
    category: "분야",
    year: "연도",
    search: "작성자/제목 검색",
    searchPlaceholder: "검색어를 입력해 주세요.",
    all: "전체",
    total: "총 게시물",
    sampleData: "샘플 데이터 표시 중",
    loading: "불러오는 중...",
    date: "날짜",
    title: "제목",
    author: "글쓴이",
    empty: "검색 결과가 없습니다.",
  },
  publicationDetailPage: {
    home: "홈",
    publications: "기고문",
    backToList: "목록으로 돌아가기",
    previous: "이전글",
    next: "다음글",
    loading: "불러오는 중...",
    notFound: "기고문 정보를 찾을 수 없습니다.",
  },
  techHomePage: {
  
    heroTitle: "기술기업의 성장과 기술권리 보호, 해외 진출과 분쟁 대응을 함께 설계합니다",
    heroText:
      "위더피플은 기술기업 자문을 중심으로 IP·기술권리, 글로벌 진출·수출, 미국 비즈니스·소송 업무를 수행합니다. 기술의 사업화와 해외거래, 관세·통상, 분쟁 대응 과정에서 필요한 법률서비스를 제공합니다.",
    contactButton: "상담 문의하기",
    what: {
      eyebrow: "WHAT",
      title: "우리가 하는 일",
      lead: "국내 기업자문, IP·기술권리, 글로벌 진출·수출, 미국 비즈니스·소송을 네 가지 업무분야로 구성했습니다.",
    },
    works: [
      {
        icon: "building",
        title: "기술기업 자문",
        text: "투자·계약·조직 운영과 분쟁 예방을 기술과 IP의 특성에 맞추어 지원합니다.",
      },
      {
        icon: "fingerprint",
        title: "IP · 기술권리 전략",
        text: "권리화, 기술보호, IP 거래·수익화와 국내외 분쟁을 함께 다룹니다.",
      },
      {
        icon: "globe",
        title: "글로벌 진출 · 수출 자문",
        text: "해외투자와 국제거래, 관세·통관·환급, 수출통제·공급망 규제를 지원합니다.",
      },
      {
        icon: "scale-balanced",
        title: "미국 비즈니스 · 소송 대응",
        text: "미국 진출과 사업운영, 관세·통상절차 및 기술·상사분쟁에 대응합니다.",
      },
    ],
    who: {
      eyebrow: "WHO",
      title: "함께하는 전문가와 협업 네트워크",
      lead: "사안에 따라 변호사, 외국변호사, 변리사, 관세사, 회계·세무 전문가 및 해외 로펌과 협업합니다.",
      note: "위더피플이 핵심 법률전략을 세우고 고객과 직접 소통합니다. 필요한 경우 IP, 관세·통상, 미국법 및 국내 기업자문 전문가와 협업하여 업무범위와 일정, 비용을 조율하고 결과물을 관리합니다.",
    },
    network: [
      ["변호사", "기술기업 자문, 계약·거래, 공정거래·분쟁, 국내 소송"],
      ["외국변호사", "미국 비즈니스·소송, 국제계약·해외 법률자문"],
      ["변리사", "특허·상표·디자인 권리화, 기술보호, IP 거래·수익화 및 분쟁 "],
      ["관세사", "품목분류·과세가격·원산지, 관세·통관·환급, 관세조사·불복"],
      ["해외 로펌", "현지법 자문, 미국·해외 소송과 관세절차, 규제·분쟁 공동수행"],
      ["회계·세무 협업", "해외법인, 조세·이전가격, 거래구조 관련 세무자문"],
    ],
    whyEyebrow: "Why WEthePEOPLE",
    whyTitle: "기술기업의 사업모델에 맞는 전문역량",
    why: [
      ["기술기업 중심의 통합 자문", "사업모델과 기술자산을 함께 살펴보고 성장 단계에 맞는 법률구조를 제시합니다."],
      ["IP·미국 소송·관세 연계", "IP 보호와 수익화, 미국 소송, 관세·통상 대응을 거래와 분쟁의 실제 흐름에 맞추어 검토합니다."],
      ["위더피플 주도의 협업체계", "위더피플이 핵심 법률전략을 세우고 고객과 직접 소통하며, 필요한 경우 국내외 전문가 및 해외 로펌과 협업합니다."],
    ],
    footerTitle: "기술기업의 성장과 해외사업에 필요한 법률문제를 함께 풀어갑니다",
    footerLead: "위더피플은 기술자산 보호와 사업화, 거래 실행, 관세·통상 대응, 국내외 분쟁 해결 과정에서 고객이 판단하고 실행하는 데 필요한 자문을 제공합니다.",
    firmName: "위더피플 법률사무소",
    address: "서울특별시 서대문구 경기대로 47, 진양빌딩 7층",
    tel: "02-2101-0750",
    email: "wtp@wtplaw.co.kr",
    privacyLabel: "개인정보처리방침",
    termsLabel: "이용약관",
  },
  techPracticePage: {
    familySite: "Family Site",
    nav: {
      about: "소개",
      practice: "업무분야",
      members: "구성원",
      insights: "인사이트",
      contact: "문의",
    },
    title: "업무분야",
    areas: [
      {
        title: "기술기업 자문",
        intro:
          "기술기업의 성장 단계와 사업모델을 바탕으로 투자, 계약, 조직 운영과 분쟁 예방에 필요한 법률문제를 검토합니다. 기술과 IP의 특성을 반영하여 국내 사업운영 과정에서 발생할 수 있는 쟁점을 미리 정리합니다.",
        items: [
          ["성장·투자구조", "설립·주주구성, 시드·시리즈 투자, 주주간계약, 스톡옵션, M&A·사업양수도"],
          ["기술사업·전략계약 ", "공동개발·PoC, OEM·ODM·공급, 플랫폼·SaaS, 유통·총판, 기술이전·라이선스"],
          ["조직·컴플라이언스 ", "이사회·주주총회, 내부통제, 개인정보·데이터, 임직원·직무발명·영업비밀"],
          ["사업 리스크·분쟁예방 ", "계약진단, 지배구조·인사·거래 분쟁, 협상·조정·소송 초기전략"],
        ],
      },
      {
        title: "IP·기술권리 전략",
        intro:
          "기술과 브랜드의 권리화, 영업비밀 보호, IP 거래와 국내외 권리행사를 함께 다룹니다. 특허법인 및 변리사와 협업하여 IP가 등록에 그치지 않고 거래와 사업화에 활용될 수 있도록 지원합니다.",
        items: [
          ["기술·브랜드 권리설계 ", "발명 발굴, 특허·상표·디자인 포트폴리오, 국내외 출원·등록, 권리범위 설계"],
          ["영업비밀·기술보호 체계 ", "비밀관리, 직무발명·성과귀속, 기술자료 제공·반출, 기술유출 대응"],
          ["IP 거래·수익화", "기술이전·라이선스, 공동개발·사업화, 로열티 구조, IP 가치평가·투자 연계"],
          ["국내외 권리행사·분쟁", "침해조사·경고·협상, 심판·소송, 무효·회피설계, 해외 권리행사·현지 로펌 협업"],
        ],
      },
      {
        title: "글로벌 진출·수출",
        intro:
          "해외시장 진입과 국제거래 구조, 관세·통관, 수출통제·경제제재 등 기술기업의 해외사업에 필요한 법률·무역 문제를 함께 다룹니다. 현지법 검토가 필요한 경우 해당 국가의 로펌과 협업하되, 국내 고객과의 소통과 전체 업무 조율은 위더피플이 담당합니다.",
        items: [
          ["해외진출·투자구조 ", "현지법인·지사, 합작투자·전략제휴, 지배구조, 현지 인허가·고용 전문가 연계"],
          ["국제거래·기술사업계약 ", "해외판매·구매, 유통·총판, OEM·ODM, 국제 라이선스, 결제·보증·물류조건"],
          ["국내 관세·통관·환급 ", "품목분류·과세가격·원산지, FTA, 관세절감·환급, 관세조사·행정불복"],
          ["수출통제·경제제재·공급망 규제 ", "전략물자·기술수출, 제재대상 심사, 강제노동·원산지 규제, 현지 규제 대응"],
        ],
      },
      {
        title: "미국 비즈니스·소송",
        intro:
          "미국 진출과 사업운영, 관세·통상절차 및 기술·상사분쟁을 함께 다룹니다. 위더피플이 국내 고객과 직접 소통하면서 미국 현지 로펌과의 협업, 자료 준비 및 전략 수립을 주도합니다.",
        items: [
          ["미국 진출·사업운영 ", "법인·투자구조, 상업계약, 고용·개인정보·컴플라이언스, 주별 규제"],
          ["미국 관세·통상절차 ", "관세 부과·환급, CBP 행정절차, IEEPA·Section 201·232·301 추가관세, 미국 국제무역법원(CIT)·연방순회항소법원 소송 공동대응"],
          ["상사·기술·IP 소송 ", "국제계약·주주·제품·기술분쟁, 디스커버리·증거보전, 중재·소송, 현지 로펌 공동수행"],
          ["미국 정부조사·규제 대응 ", "DOJ·FTC 등 정부조사 대응, 인수합병 신고(HSR)·심사, 수출통제·제재 컴플라이언스, 내부조사·시정조치"],
        ],
      },
    ],
    firmName: "위더피플 법률사무소",
    address: "서울특별시 서대문구 경기대로 47, 진양빌딩 7층",
    tel: "02-2101-0750",
    email: "wtp@wtplaw.co.kr",
  },
  techContactPage: {
    title: "문의",
    lead: "아래 양식을 남겨주시면 담당 변호사가 검토 후 최대한 빠르게 회신드립니다.",
    nameLabel: "성함",
    namePlaceholder: "홍길동",
    companyLabel: "회사 / 소속",
    companyPlaceholder: "위더피플 주식회사",
    emailLabel: "이메일",
    emailPlaceholder: "name@company.com",
    phoneLabel: "연락처",
    phonePlaceholder: "010-0000-0000",
    urgentPhone: "02-2101-0750",
    urgentPhoneHref: "tel:0221010750",
    categoryLabel: "문의 분야",
    categories: ["기술기업 자문", "IP·기술권리", "글로벌 진출·수출", "미국 비즈니스 · 소송", "공정거래 · 플랫폼", "인사 · 노무", "기타"],
    messageLabel: "문의 내용",
    messagePlaceholder: "검토가 필요한 사안과 배경을 간략히 적어주세요.",
    privacyText: "개인정보 수집 및 이용(문의 응대 목적, 보관 1년)에 동의합니다.",
    privacyLink: "자세히 보기",
    submitButton: "문의 보내기",
    submittingButton: "전송 중...",
    requiredMessage: "성함, 이메일, 문의 내용, 개인정보 동의는 필수입니다.",
    successMessage: "문의가 접수되었습니다. 곧 회신드리겠습니다.",
    errorMessage: "문의 제출 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    processTitle: "문의 절차",
    steps: [
      { title: "문의 접수", text: "양식을 남겨주시면 담당 팀이 사안을 확인합니다." },
      { title: "담당 변호사 배정", text: "분야에 맞는 변호사·변리사·관세사를 배정합니다." },
      { title: "회신 및 상담", text: "검토 후 최대한 빠르게 회신드리며, 필요 시 대면·화상 상담을 진행합니다." },
    ],
    urgentTitle: "긴급한 사안이신가요?",
    urgentText: "평일 09:00-18:00에는 전화로 담당 변호사에게 바로 연결해 드립니다.",
  },
  casePage: {
    home: "주요 Track Record",
  },
  internationalPage: {
    title: "공유가치소송센터",
    overview: (
      <>
        ‘공유가치창출(Creating Shared Value, CSV)’이란 기업의 경제적 가치 창출과
        사회적 가치 증진이 상충하는 것이 아니라, 기업이 경제적∙사회적 환경을
        개선해 나가는 과정에서 기업과 주주의 가치가 함께 증대될 수 있다는
        개념입니다. 이는 기업이 사회적 문제 해결에 기여하면서 동시에 지속가능한
        경제적 성과를 달성하는 경영전략을 의미합니다. ESG 경영이 강조되는 오늘날
        그 중요성은 더욱 커지고 있습니다.
        <br />
        <br />
        위더피플 법률사무소 CSV Litigation Center는 CSV 개념을 소송의 영역에서
        구현하고자 합니다. 글로벌 기업의 담합, 환경·소비자 피해, 시장질서 교란
        행위, 개인정보 유출 등은 사회 전반의 신뢰를 훼손함과 동시에 기업과
        주주의 경제적 가치에도 심각한 손해를 초래합니다. 이러한 침해행위는
        책임을 명확히 함으로써 재발을 방지하고 실질적인 회복을 도모할 수
        있습니다.
        <br />
        <br />
        CSV Litigation Center는 이처럼 기업·주주·사회가 공동으로 향유해야 할
        가치를 침해하는 중대한 위법행위에 대하여, 대규모 손해배상청구 소송,
        주주대표소송, 공익적 책임추궁 소송 등을 수행합니다. 아울러 국내소송은
        물론, 국제소송(Cross-Border Litigation)의 영역에서도 종합적인 해결책을
        모색합니다.
        <br />
        <br />
        궁극적으로 CSV Litigation Center는 단기적인 피해 회복이나 개별 분쟁의
        해결을 넘어, 책임과 준법의 구조가 기업과 시장에 정착될 수 있도록 하는 데
        주력하고 있습니다.
      </>
    ),
    whyUs: (
      <>
        {" "}
        <Item>
          <Description>
            위더피플 법률사무소는 지난 15년간 글로벌 기업의 담합 및 불공정행위
            등 위법행위로 인해 발생한 국내 피해 사건을 중심으로, 국내외 법원에서
            대기업, 중견∙중소기업, 개인에 이르기까지 다양한 산업군의 의뢰인을
            대리하며 의미 있는 성과를 축적해 왔습니다.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            대규모∙집단적 성격의 소송은 절차의 복잡성, 증거 확보의 어려움, 비용
            구조 등으로 인해 높은 진입 장벽을 갖는 영역입니다. CSV Litigation
            Center는 피해자 원고 구성, 증거 확보∙분석, 다층적 피해 구조의 규명,
            소송 전략 수립, 협상 및 판결에 이르기까지 소송 전 과정에 대한
            전략적인 대응을 수행합니다.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            착수금 없이 진행되는 ‘No Win, No Fee’ 방식의 성공보수 기반 소송
            구조를 통해, 의뢰인의 정당한 권리구제가 비용 문제로 인해 제한되지
            않도록 하며, 결과 중심의 소송 수행을 지향합니다.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            국제소송(Cross-Border Litigation) 분야에서는, Hausfeld LLP, Cohen
            Milstein LLP, Saxena White P.A. 등 세계적인 국제소송 전문 해외
            로펌과의 긴밀한 협력을 바탕으로, 국내 의뢰인이 단독으로 대응하기
            어려운 글로벌 분쟁에 대하여 공동소송 및 집단적 대응 구조를
            주도적으로 설계∙수행합니다.
          </Description>
        </Item>
      </>
    ),

    services: (
      <>
        <div>
          <Title>1. 공유가치 침해에 대한 책임소송</Title>
          <Item>
            <Description>
              글로벌 기업의 담합, 불공정거래, 경쟁 제한 행위 등에 대한 책임추궁
            </Description>
            <Description>
              환경·소비자·금융·투자자 피해 등 집단적 손해 사건
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. 주주∙이해관계자 권리 보호</Title>
          <Item>
            <Description>주주대표소송 및 경영진 책임 관련 분쟁</Description>
            <Description>
              위법행위로 인한 기업가치 훼손에 대한 회복 전략
            </Description>{" "}
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. 집단적 소송 구조 설계</Title>
          <Item>
            <Description>피해∙책임 구조 분석 및 원고 집단 구성</Description>
            <Description> 증거 확보·분석 및 손해액 산정∙입증 전략</Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. 국제소송 및 공동대응</Title>
          <Item>
            <Description>해외 로펌과의 협력 기반 공동소송</Description>
            <Description>전략적 관할 선택 및 글로벌 합의 절차 지원</Description>
            <Description>
              미국 주·연방법원 및 ITC 등 주요 해외 관할 대응
            </Description>
          </Item>{" "}
        </div>
      </>
    ),
  },
  monetizationPage: {
    title: "IP수익화센터",
    overview: (
      <>
        위더피플 법률사무소 IP Monetization Center는 지식재산권(Intellectual
        Property Right, IPR)을 기반으로 한 수익 구조를 설계, 구현하는 지식재산
        수익화 전문조직입니다.
        <br />
        <br />
        지식재산 수익화(IP Monetization)는 크게 다음 두 가지 방식으로
        이루어집니다.
        <Title>1. 침해 기반 수익화 </Title>
        <Item>
          <Description>
            침해자를 상대로 한 손해배상 소송 또는 라이선스 협상을 통한 로열티
            확보
          </Description>
        </Item>
        <Title>2. 거래 기반 수익화</Title>
        <Item>
          <Description>
            매각, 라이선싱 아웃을 통한 자산화 및 현금흐름 창출
          </Description>
        </Item>
        이러한 수익화 방식은 권리와 시장 환경에 따라 전략적으로 선택,
        결합됩니다.
        <br />
        <br />
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>특허 부문</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        특허는 단순한 독점권이 아니라, 침해 대응과 거래 구조를 통해 가치를
        극대화할 수 있는 핵심 비즈니스 자산입니다. IP Monetization Center는
        수익화 대상 특허 발굴, 가치·침해 분석, 시장 및 타깃 조사, 소송·협상,
        거래 체결에 이르기까지 특허수익화 전 과정을 체계적으로 수행합니다.
        <br />
        <br />
        아울러 R&D 단계에서부터 수익 창출을 고려한 특허 포트폴리오 설계 전략을
        지원하고, 국내외 출원 및 권리범위 최적화 업무를 제공합니다.
        <br />
        <br />
        중소기업, 대학, 연구기관 등은 보유 특허의 가치를 충분히 활용하지
        못하거나 수익화 가능성을 인지하지 못하는 경우가 많습니다. 당소는
        미국∙한국 특허 전문 변호사∙변리사와 글로벌 기술기업 출신 IP 전문가의
        협업을 통해 고객의 특허 포트폴리오를 전반적으로 분석하고, 실현 가능한
        수익화 모델을 제시합니다.
        <br />
        <br />
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>상표/디자인/저작권 부문</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        상표·디자인·저작권 역시 침해소송, 매각, 라이선싱을 통해 수익 실현이
        가능한 비즈니스 자산입니다. IP Monetization Center는 침해자를 상대로 한
        손해배상청구 및 라이선스 협상, IP 매각과 라이선싱 아웃을 통해 권리의
        경제적 가치를 실현합니다.
        <br />
        <br />
        나아가 IP가 브랜드 매니지먼트, 콘텐츠 사업, 파생 상품·서비스 등을 통해
        수익화될 수 있도록 법률적 구조를 설계합니다. 이 과정에서 권리범위,
        수익귀속, 계약구조, 침해 리스크를 분석하여, IP 활용이 안정적이고
        지속가능한 수익 모델로 이어지도록 합니다.
        <br />
        <br />
        또한 자매사들과의 협업 네트워크를 바탕으로, 기존 IP가 음악, 영화, 패션,
        캐릭터, 공연예술 등 다양한 산업 영역에서 새로운 수익 모델로 확장될 수
        있도록 지원합니다.
      </>
    ),
    whyUs: (
      <>
        {" "}
        <Item>
          <Description>
            특허를 매입해 직접 수익을 취하는 일반 NPE(Non-Practicing Entity)와
            달리, 권리 이전 없이 권리자가 IP를 보유한 상태에서 추가 사업, 기술
            확장 등 지속가능한 수익화를 실현할 수 있도록 지원합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            LG, 삼성, 서울반도체 등 기업에서 IP 전략 및 미국 특허소송을 총괄한
            전문가들이 기업의 사업전략과 연계된 수익화 구조를 설계합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            국내외 대형로펌 출신의 특허 전문 미국변호사∙미국변리사가 유수의 미국
            특허로펌 및 e-디스커버리 업체와 협업하여 미국 시장 중심의 고부가가치
            수익화를 수행합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            리인터내셔널 특허법률사무소, 특허법인 위더피플, 라이카㈜ 등 변리사
            100여 명과 엔지니어 300여 명 규모의 자매사들과의 협업을 통해 IP
            분석, 기술검증, 거래 매칭까지 연계합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            성공보수 기반, 하이브리드 모델 등 유연한 보수 구조를 통해 권리자의
            부담을 최소화합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            상표∙디자인∙저작권 분야에서는 ㈜인피니트그룹(CI∙BI 디자인 전문기업),
            ㈜인피니스(브랜드 매니지먼트 전문기업) 등 자매사들과의 협업을 통해
            IP 기반 사업 확장이 가능하도록 법률적 구조를 설계합니다.
          </Description>
        </Item>
        <Item>
          <Description>
            지난 15년간 축적된 글로벌 소송 경험을 바탕으로, ‘권리 보호, 침해
            억제, 정당한 보상의 실현’이라는 철학을 IP 수익화 업무 전반에
            적용하고 있습니다.
          </Description>
        </Item>
      </>
    ),
    services: (
      <>
        <div>
          <Title>1. IP 포트폴리오 구축 및 전략 설계</Title>
          <Item>
            <Description>수익화를 고려한 IP 포트폴리오 설계</Description>
            <Description>
              출원 전략 수립 및 권리범위 최적화 (미국 직접 출원, Office
              Action(OA), Continuation Application(CA) 등)
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. 침해 기반 수익화</Title>
          <Item>
            <Description>IP 침해분석, 시장조사, 타겟조사</Description>
            <Description>
              국내외 소송 및 라이선스 협상을 통한 손해배상∙로열티 확보
            </Description>{" "}
            <Description>
              미국 소송 및 ITC 절차 대응, 소송비용 펀딩 연계
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. 거래 기반 수익화</Title>
          <Item>
            <Description>IP 매각∙라이선싱 아웃 구조 설계</Description>
            <Description>매입∙라이선싱 의향 기업 조사 및 매칭</Description>
            <Description>계약서 작성, 협상 및 법률 검토</Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. IP 사업화 및 확장 구조 설계</Title>
          <Item>
            <Description>
              상표∙디자인∙저작권 기반 브랜드 및 콘텐츠 사업화 구조 설계
            </Description>
            <Description>
              수익귀속, 권리보호, 침해 리스크 고려한 계약 및 라이선스 구조 설계
            </Description>
          </Item>{" "}
        </div>{" "}
      </>
    ),
  },
  caseDetailPage: {
    home: "홈",
    keyCases: "주요 Track Record",
    backtoList: "목록으로 돌아가기",
    previous: "이전글",
    next: "다음글",
  },
  popup: {
    dontOpen: "오늘 하루 열지 않기",
    close: "닫기",
  },
  slider: {
    insight: "인사이트",
  },
  parter: {
    title: "파트너사",
    sub: "주요 파트너사",
  },
};

export default Kr;
